require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-michael-porter-microbiologist-turned-software-engineer.json") })
        }
      }, "path---blog-meet-michael-porter-microbiologist-turned-software-engineer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-michael-porter-microbiologist-turned-software-engineer!./.cache/json/blog-meet-michael-porter-microbiologist-turned-software-engineer.json
// module id = 973
// module chunks = 231608221292675